import React from 'react';

const IngredientDisclosure=({ingredients})=>{
  const value=String(ingredients || '').trim();

  if (!value) return null;

  return (
    <details
      className="mt-5 rounded-2xl border border-slate-100 bg-slate-50"
      onClick={(event)=>event.stopPropagation()}
    >
      <summary className="cursor-pointer list-none px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-500">
        Ingredients
      </summary>
      <p className="border-t border-slate-100 px-4 py-4 text-sm font-medium leading-relaxed text-slate-600">
        {value}
      </p>
    </details>
  );
};

export default IngredientDisclosure;